module.exports = __webpack_public_path__ + "media/images/webpage/hotels/staff_members/ryokan_worker_male-a841d3e368ec8a661e4e05a72b531854.webp";